import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvCxAssignToolDTO, CvCxAssignToolOptions, CvCxEntities } from 'src/app/reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.models';
import { CvCxoneAssignToolComponent } from 'src/app/reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.component';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { cloneDeep } from 'lodash';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { first } from 'rxjs/operators';
import { GameType } from 'src/app/dashboard/modals/cxone-award-modal/cxone-award.model';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'cv-configure-eligibility',
  templateUrl: './configure-eligibility.component.html',
  styleUrls: ['./configure-eligibility.component.scss'],
  providers: [DialogService]
})
export class ConfigureEligibilityComponent implements OnInit {
  @Input() step: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  assignToolVisible: boolean = false;
  empColumns = [];
  recColumns = [];
  totEmpGroups: number = 0;
  totRecGroups: number = 0;
  empExpanded: boolean = false;
  recExpanded: boolean = false;
  secondLevelName: string = "";
  assignedGroups = [];
  assignModal: DynamicDialogRef;
  defaultCategorySelection = {};
  isCxOne: boolean = false;

  constructor(
    private gamesService: GamesService,
    private dialogService: CvDialogService,
    private cvConfigService: CvConfigurationService,
    private customDialogService: CvCustomDialogService,
    private cvLocalization: CVLocalizationService,
    private dialogSrvc: DialogService,
  ) {
    this.gs = this.gamesService.data;
    $(document).on("AssignToolObjectiveSaveEvt", this.onAssignToolSave);
  }

  ngOnInit(): void {
    this.gs.modified.item.underlyingRule.AutoJoin = (this.gs.modified.item.underlyingRule.AutoJoin) ? this.gs.modified.item.underlyingRule.AutoJoin : false;

    this.gamesService.loadGroupTypes().then((result: any) => {
      this.secondLevelName = result.EmpGroupTypes.find((empGroup) => { return empGroup.GroupLevel == 2; }).GroupTypeName;
    });

    if (this.gs.modified.item.Eligibility != undefined && this.gs.modified.item.Eligibility.AssignedGroups != undefined
      && this.gs.modified.item.Eligibility.AssignedGroups.emp != undefined && this.gs.modified.item.Eligibility.AssignedGroups.rec != undefined) {
      this.setData();
    }

    this.isCxOne = this.cvConfigService.isCxOne;
  }

  setData(): void {
    this.empExpanded = false;
    this.recExpanded = false;

    if (this.gs.modified.item.Eligibility.AssignedGroups.emp.length > 0) {
      this.empColumns = this.gs.modified.item.Eligibility.AssignedGroups.emp;
      this.totEmpGroups = this.empColumns.length;
    }

    if (this.gs.modified.item.Eligibility.AssignedGroups.rec.length > 0) {
      this.recColumns = this.gs.modified.item.Eligibility.AssignedGroups.rec;
      this.totRecGroups = this.recColumns.length;
    }

    this.empColumns.sort((a, b) => {
      if (a.GroupName < b.GroupName)
        return -1;

      if (a.GroupName > b.GroupName)
        return 1;

      return 0;
    });

    this.recColumns.sort((a, b) => {
      if (a.GroupName < b.GroupName)
        return -1;

      if (a.GroupName > b.GroupName)
        return 1;

      return 0;
    });

    this.empColumns = this.columnize(this.empColumns.slice(0, 21));
    this.recColumns = this.columnize(this.recColumns.slice(0, 21));
  }

  columnize(arr) {
    var newArr = [];

    for (var i = 0; i < 3; i++) {
      var tmpArray = [];
      for (var j = i; j < arr.length; j += 3) {
        tmpArray.push(arr[j]);
      }
      newArr.push(tmpArray);
    }

    return newArr;
  }

  expandList(groupType: string): void {
    switch (groupType) {
      case 'emp':
        if (!this.empExpanded) {
          this.empColumns = this.columnize(this.gs.modified.item.Eligibility.AssignedGroups.emp);
        } else {
          this.empColumns = this.columnize(this.gs.modified.item.Eligibility.AssignedGroups.emp.slice(0, 21));
        }

        this.empExpanded = !this.empExpanded;
        break;
      case 'rec':
        if (!this.recExpanded) {
          this.recColumns = this.columnize(this.gs.modified.item.Eligibility.AssignedGroups.rec);
        } else {
          this.recColumns = this.columnize(this.gs.modified.item.Eligibility.AssignedGroups.rec.slice(0, 21));
        }

        this.recExpanded = !this.recExpanded;
        break;
    }
  }

  getGroupType(type: string): string {
    if (this.gs.modified.item.Eligibility.AssignedGroups.emp != undefined || this.gs.modified.item.Eligibility.AssignedGroups.rec != undefined) {
      switch (type) {
        case 'emp':
          if (this.gs.modified.item.Eligibility.AssignedGroups.emp.length > 0) {
            var gtmatch = this.gs.GroupTypes.filter((gt) => { return gt.BaseGroupType == 0 && gt.GroupLevel == this.gs.modified.item.Eligibility.AssignedGroups.emp[0].GroupLevel });
            if (gtmatch != null && gtmatch.length > 0)
              return gtmatch[0].GroupTypeName;
          }
          break;
        case 'rec':
          if (this.gs.modified.item.Eligibility.AssignedGroups.rec.length > 0) {
            var gtmatch = this.gs.GroupTypes.filter((gt) => { return gt.BaseGroupType == 1 && gt.GroupLevel == this.gs.modified.item.Eligibility.AssignedGroups.rec[0].GroupLevel });
            if (gtmatch != null && gtmatch.length > 0)
              return gtmatch[0].GroupTypeName;
          }
          break;
      }
    }
  }

  deleteSelection(type: string): void {
    if (this.cvConfigService.isCxOne) {  
      const modalOptions: NgbModalOptions = {
        keyboard: false,
        backdrop: 'static',
        centered: true,
        windowClass: 'cxone-create-warning-modal'
      };
  
      this.customDialogService.showDialog(
        this.getLocalizedMessage("Confirm_Remove", "Confirm Remove"),
        this.getLocalizedMessage("Confirm_Remove_Message", "Are you sure you want to remove this group of participants?"),
        11,
        this.gamesService.getLocalizedMessage("Cancel", "Cancel"),
        this.gamesService.getLocalizedMessage("Ok", "Ok"),
        true,
        () => {
          // OK callback
          if (type == 'emp') {
            this.gs.modified.item.Eligibility.AssignedGroups.emp = [];
          }
          
          if (type == 'rec') {
            this.gs.modified.item.Eligibility.AssignedGroups.rec = [];
          }
        },
        () => {
          // Cancel callback
        },
        'cxone-modal-game-warning',
        true,
        modalOptions
      );
    } else {
      this.dialogService.showConfirmDialog(
        this.getLocalizedMessage("Confirm_Remove", "Confirm Remove"),
        this.getLocalizedMessage("Confirm_Remove_Message", "Are you sure you want to remove this group of participants?"),
        false,
        () => {
          if (type == 'emp') {
            this.gs.modified.item.Eligibility.AssignedGroups.emp = [];
          }
  
          if (type == 'rec') {
            this.gs.modified.item.Eligibility.AssignedGroups.rec = [];
          }
        }
      );
    }
  }

  setAssignToolData() {
    const assignedGroups = cloneDeep(this.gs.modified.item.Eligibility.AssignedGroups);
    if (assignedGroups && assignedGroups.emp && assignedGroups.rec) {
      const { emp, rec } = assignedGroups;
      this.assignedGroups = [...emp, ...rec];
    }
    this.assignToolVisible = true;
  }

  onAssignToolSave = (args: any) => {
    //Timeout required because this event and the one that sets the AssignedGroups.emp/rec lists both happen at the same time, thus this event can hit first (causing an undefined propery index error)    
    setTimeout(() => {
      if (this.assignedGroups.length > 0) {
        this.gs.modified.item.Eligibility.AssignedGroups = [];

        let tmpObj = cloneDeep(this.assignedGroups);
        const emp = tmpObj.filter((g) => { return g.BaseGroupType == 0 });
        const rec = tmpObj.filter((g) => { return g.BaseGroupType == 1 });
        this.gs.modified.item.Eligibility.AssignedGroups = {
          emp,
          rec
        };

        this.setData();
        var eventArgs = {
          currentStep: this.step - 1,
          unlocks: this.componentOptions.unlocks
        };
        this.componentComplete.emit(eventArgs);
      }
    }, 1);
  }

  getLocalizedMessage(key: string, value: string): string {
    return this.gamesService.getLocalizedMessage(key, value);
  }

  getEligibilityDescription(eligibilityAllowed: string) {
    const defaultText = 
      `Select "${eligibilityAllowed}" to participate in the game. Each "${eligibilityAllowed}" will be automatically added to the game. Only "${eligibilityAllowed}" are eligible to play this game.`
    const localizedMessage = this.getLocalizedMessage('Eligibility_Description', defaultText);
    return localizedMessage.replaceAll("{{0}}", eligibilityAllowed); 
  }
  
  hideAutojoin(): boolean {
    if (this.cvConfigService.isCxOne) {
      this.gs.modified.item.underlyingRule.AutoJoin = true;
      const gameType: GameType = this.gs.modified.item.underlyingRule.GameType;
      const gameTypeValues = Object.values(GameType);
      return gameTypeValues.indexOf(gameType) === -1;
    }

    return this.gs.modified.item.underlyingRule.Category != 3;
  }

  getLocalizationString(key: string, defaultValue: string) {
    return this.cvLocalization.getCachedText("Games", key, defaultValue);
  }

  openCxOneRecordingGroupModal() {
    this.openModal(this.gs.modified.item.Eligibility.AssignedGroups.rec, 'rec');
  }

  openCxOneEmployeeGroupModal() {
    this.openModal(this.gs.modified.item.Eligibility.AssignedGroups.emp, 'emp');
  }

  openModal(assignedGroups: any, entityType: 'emp' | 'rec' | 'agentAttribute' | 'login'): void {
    if (this.assignModal != null) return;

    let assigned: CvCxEntities = {
      emp: [],
      rec: [],
      agentAttribute: [],
      login: []
    };

    // Assign group
    assigned[entityType] = assignedGroups;

    // Check if the entityType is true to return that on the assign tool
    const showTypeValues = {
      emp: entityType === 'emp',
      rec: entityType === 'rec',
      agent_att: entityType === 'agentAttribute',
      logins: entityType === 'login'
    };

    const getLocalization = (key: string, defaultValue: string) =>
      this.getLocalizationString(key, defaultValue);

    // Define messages and titles based on entityType
    const localizationData = {
      emp: {
        singleAssignMessage: getLocalization("Assign_Single_Group_Message_Games", "A game can be assigned to either an agent or a team, but not both."),
        modalTitle: getLocalization("Assign_Employee_Group", "Assign Employee Group")
      },
      rec: {
        singleAssignMessage: getLocalization("Assign_Single_Group_Message_Games_Skills", "A game can be assigned to either a skill or a campaign, but not both."),
        modalTitle: getLocalization("Assign_Contact_Group", "Assign Contact Group")
      },
      agentAttribute: {
        singleAssignMessage: getLocalization("Assign_Single_Group_Message_Games", "A game can be assigned to either an agent or a team, but not both."),
        modalTitle: getLocalization("Assign_Employee_Group", "Assign Employee Group")
      },
      login: {
        singleAssignMessage: getLocalization("Assign_Single_Group_Message_Games", "A game can be assigned to either an agent or a team, but not both."),
        modalTitle: getLocalization("Assign_Employee_Group", "Assign Employee Group")
      }
    };

    // Retrieve appropriate messages and title
    const { singleAssignMessage, modalTitle } = localizationData[entityType];

    let options: CvCxAssignToolOptions = {
      modalTitle: modalTitle,
      modalSaveLabel: this.getLocalizationString("Assign_Button", "Assign"),
      modalCancelLabel: this.getLocalizationString("Cancel", "Cancel"),
      useBulkAdd: false,
      singleAdd: false,
      singleLevel: true,
      singleType: true,
      showTypeValues: showTypeValues,
      assignedEntities: assigned,
      minEmpLevel: this.gs.modified.item.underlyingRule.Category == 3 ? 2 : 1,
      maxEmpLevel: 2,
      maxRecLevel: 3,
      minRecLevel: 2,
      singleAssignValidation: true,
      singleAssignMessage: singleAssignMessage
    };

    this.assignModal = this.dialogSrvc.open(CvCxoneAssignToolComponent, {
      width: "1198px",
      height: "720px",
      baseZIndex: 10000,
      data: {
        options: options
      },
      styleClass: 'cx-one-ui product-assignment-modal btn-bg-is-white'
    });

    this.assignModal.onClose.pipe(first()).subscribe(dto => this.closeAssignTool(dto, entityType));
  }

  closeAssignTool(dto: CvCxAssignToolDTO, entityType: 'emp' | 'rec' | 'agentAttribute' | 'login'): void {
    if (dto != null) {
      switch (entityType) {
        case 'emp':
          this.gs.modified.item.Eligibility.AssignedGroups.emp = [...dto.selected['emp'], ...dto.assigned['emp']];
          this.getAssignedEmployees();
          break;
        case 'rec':
          this.gs.modified.item.Eligibility.AssignedGroups.rec = [...dto.selected['rec'], ...dto.assigned['rec']];
          this.getAssignedRecordings();
          break;
        default:
          break;
      }

      setTimeout(() => {
        this.gs.modified.item.Eligibility.AssignedGroups = {
          "emp": this.gs.modified.item.Eligibility.AssignedGroups.emp !== undefined ? this.gs.modified.item.Eligibility.AssignedGroups.emp : [],
          "rec": this.gs.modified.item.Eligibility.AssignedGroups.rec !== undefined ? this.gs.modified.item.Eligibility.AssignedGroups.rec : [],
        };
      }, 1);

      if (this.gs.modified.item.Eligibility.AssignedGroups.emp !== undefined || this.gs.modified.item.Eligibility.AssignedGroups.rec !== undefined) {
        const eventArgs = {
          currentStep: this.step - 1,
          unlocks: this.componentOptions.unlocks
        };
        this.componentComplete.emit(eventArgs);
      }
    }

    this.assignModal = null;
  }

  getAssignedEmployees(): void {
    this.empExpanded = false;
    if (this.gs.modified.item.Eligibility.AssignedGroups.emp.length > 0) {
      this.empColumns = this.gs.modified.item.Eligibility.AssignedGroups.emp;
      this.totEmpGroups = this.empColumns.length;
    }
    this.empColumns.sort((a, b) => {
      if (a.GroupName < b.GroupName)
        return -1;

      if (a.GroupName > b.GroupName)
        return 1;

      return 0;
    });
    this.empColumns = this.columnize(this.empColumns.slice(0, 21));
  }

  getAssignedRecordings(): void {
    this.recExpanded = false;

    if (this.gs.modified.item.Eligibility.AssignedGroups.rec.length > 0) {
      this.recColumns = this.gs.modified.item.Eligibility.AssignedGroups.rec;
      this.totRecGroups = this.recColumns.length;
    }

    this.recColumns.sort((a, b) => {
      if (a.GroupName < b.GroupName)
        return -1;

      if (a.GroupName > b.GroupName)
        return 1;

      return 0;
    });

    this.recColumns = this.columnize(this.recColumns.slice(0, 21));
  }
}
